import { CreateNewProjectThemeModeConfig } from './types';

const light: CreateNewProjectThemeModeConfig = {
  createNewProject: {},
};

export default light;
